import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { Button, Card } from "antd";
import Text from "antd/es/typography/Text";

export function ExcelTemplate({ handleDownloadTemplate , templateType, requiredColumns}){
    return(
        <Card
                    title="Download Template"
                    style={{ borderRadius: 12, border: "1px solid #f0f0f0", display: "flex", flexDirection: "column", height: "100%" }}
                  >
                    <div style={{ width: "100%", marginBottom: 16 }}>
                      <Button
                        icon={<FileDownloadOutlinedIcon style={{ fontSize: 18 }} />}
                        onClick={handleDownloadTemplate}
                        style={{ borderColor: "#047857", color: "#047857", width: "100%", height: 50, whiteSpace: "normal", display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}
                      >
                       <span
                       style={{fontSize: 14, fontWeight: 500, textAlign: "center", lineHeight: 1.4}}
                       > {templateType} Template (.xlsx)</span>
                      </Button>
                    </div>
                    <Text style={{ fontSize: 12, color: "#8c8c8c", lineHeight: 1.6 }}>
                      Required Excel columns: {requiredColumns}
                    </Text>
                  </Card>
    )
}